/**
 * @generated SignedSource<<74089c4866f148c1c8cc193eba001731>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ResponseValidationType = "AL" | "AM" | "BE" | "EX" | "%future added value";
export type ScreenersCharacteristicTypeChoices = "DT" | "GS" | "MS" | "NM" | "OE" | "SS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CharacteristicsEditPage_tenant$data = {
  readonly characteristics: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answers: ReadonlyArray<{
          readonly id: string;
          readonly other: boolean;
          readonly text: string;
          readonly userSpecified: boolean;
        }>;
        readonly elementMeta: {
          readonly randomize: boolean | null;
          readonly responseValidation: ResponseValidationType | null;
          readonly target: number | null;
          readonly target2: number | null;
          readonly targetTypes: ReadonlyArray<string> | null;
        };
        readonly id: string;
        readonly importKey: string;
        readonly rows: ReadonlyArray<{
          readonly id: string;
          readonly text: string;
        }>;
        readonly shortName: string;
        readonly showToPanelists: boolean;
        readonly text: string | null;
        readonly type: ScreenersCharacteristicTypeChoices;
      } | null;
    } | null>;
  };
  readonly dId: any | null;
  readonly name: string;
  readonly vpmAccountId: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"EditCharacteristicActive_tenant">;
  readonly " $fragmentType": "CharacteristicsEditPage_tenant";
};
export type CharacteristicsEditPage_tenant$key = {
  readonly " $data"?: CharacteristicsEditPage_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"CharacteristicsEditPage_tenant">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CharacteristicsEditPage_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CharacteristicNodeConnection",
      "kind": "LinkedField",
      "name": "characteristics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CharacteristicNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CharacteristicNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shortName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showToPanelists",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "importKey",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CharacteristicElementMetaNode",
                  "kind": "LinkedField",
                  "name": "elementMeta",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "randomize",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "responseValidation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "target",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "target2",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetTypes",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CharacteristicAnswerNode",
                  "kind": "LinkedField",
                  "name": "answers",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "other",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "userSpecified",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CharacteristicRowNode",
                  "kind": "LinkedField",
                  "name": "rows",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vpmAccountId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditCharacteristicActive_tenant"
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};
})();

(node as any).hash = "71a45656a0b997352997aabc30ec9ed0";

export default node;
